import { useEffect, useState } from "react";
import BlockUnitGrid from "../../BlockUnitGrid/BlockUnitGrid";
import { useGlobalState } from "../../../GlobalState";
import { Block } from "../../Block/Block";
import { v4 as uuidv4 } from 'uuid';

/**
 * 
 * @param {*} params 
 * @returns 
 */
export function GameBoardGrid( { params } ){

    const LENGTH = 7;
   
    const [shape, setShape] = useState(new Array(LENGTH).fill(new Array(LENGTH).fill(0)));
    const { selectedBlock, setSelectedBlock, blocks, setBlocks, score, setScore, setGameOver } = useGlobalState();
    

    params.shape = shape;
    params['rowCount'] = LENGTH;
    params['colCount'] = LENGTH;
    params['onClickCallback'] = (event)=>{
        if(selectedBlock){
            // we have the block shape. we need to know:
             
            const row = Number(event.currentTarget.getAttribute("row"))
            const col = Number(event.currentTarget.getAttribute("column"))

            // Validate & place move
            // Validate - every 1 on shape must map to a 0 (not 1 or undefined) on this.shape
            const sbHeight = selectedBlock.shape.length-1;
            const sbLength = selectedBlock.shape[0].length-1;
            
            const centerOffsetHeight = Math.floor(sbHeight/2.0); // 2/2 =1 
            const centerOffsetLength = Math.floor(sbLength/2.0);

           // const center = [row, col]
            var isValid = true;
            const newShape = JSON.parse(JSON.stringify(shape))
            for(let i = 0; i <= sbHeight; i++){
               
                for(let j = 0; j <= sbLength; j++){
                    const selectedBlockValue = selectedBlock.shape[i][j];
             
                    if(selectedBlockValue === 0 || !isValid)
                        continue;

                    
                    // If move is good, update shape copy. If not, break and set is valid to false
                    const comparingCellRow = (()=>{
                        if(i === centerOffsetHeight)
                            return row;
                        else if(i > centerOffsetHeight)
                            return row+(i-centerOffsetHeight) < LENGTH ? row+(i-centerOffsetHeight) : null;
                        else
                            return row-(i+centerOffsetHeight) >= 0 ? row-(i+centerOffsetHeight) : null;  
                    })()

                    const comparingCellCol = (()=>{
                        if(j === centerOffsetLength)
                            return col;
                        else if(j > centerOffsetLength){
                            return col+(j-centerOffsetLength) < LENGTH ? col+(j-centerOffsetLength) : null;
                        }
                        else
                            return col-(j+centerOffsetLength) >= 0 ? col-(j+centerOffsetLength) : null;  
                    })()

                    
                    if(comparingCellCol === null || comparingCellRow === null || shape[comparingCellRow][comparingCellCol] === 1){
                        isValid = false;
                        break;
                    }
                    
                    // OK
                    newShape[comparingCellRow][comparingCellCol] = 1;
                }
            }
            
            if(isValid){
                console.log("Move made!")

                // Update the tray with a new random block
                const blockIndex = selectedBlock.trayIndex;
                const newTrayBlocks = [...blocks];
                const id = uuidv4();
                newTrayBlocks[blockIndex] = (<Block params={{index:blockIndex, id:id}} key={id}></Block>);
                setBlocks(newTrayBlocks);

                // Remove block
                setSelectedBlock(false);
                setShape(updateBoard(newShape));
            
            }
            else{
                console.log("NOT A VALID MOVE LEARN THE RULES!!!!!")
            }

        }
    }

    /**
     * IS THE GAME OVER - ON NEW BLOCK
     */
    useEffect(()=>{
        var pathFound = false;
        shape.forEach(( row, i )=>{
            if(pathFound)
                return;
            row.forEach(( value, j )=>{
                if( !pathFound && value === 0 ){
                    blocks.forEach(( block )=>{

                        // For each block
                        if( !pathFound && findPath( block, [i,j] ) ){
                            pathFound = true;
                        }
                    })
                }
            });
        });
        setGameOver(!pathFound)

    }, [blocks]);

    function findPath( block, start ){
        // start is assumed to be 0
        // check is
        const blockDOM = document.getElementById(block.props.params.id);
        const blockPath = JSON.parse(blockDOM.dataset.path);

        for(let i = 0; i < blockPath.length; i++){
            const move = blockPath[i];
            switch(move){
                case 'up':
                    start[0]--;
                    break;
                case 'down':
                    start[0]++;
                    break;
                case 'left':
                    start[1]--;
                    break;
                case 'right':
                    start[1]++;
                    break;
            }
            const value =  shape?.[start[0]]?.[start[1]];
           
            if( value === 1 || value === undefined)
                return false;
        };

        return true;
    }

    /**
     * Update on block place
     * @param {*} shape 
     * @returns 
     */
    function updateBoard(shape){
        const newShape = JSON.parse(JSON.stringify(shape))
        const rowsToRemove = [];
        const colToRemove = [];

        // Update
        newShape.forEach((row, i)=>{
            if(!row.includes(0))
                rowsToRemove.push(i)
        })

        for( let i = 0; i < LENGTH; i++ ){
            const col = [];
            for( let j = 0; j < LENGTH; j++ ){
                col.push(shape[j][i])
            }
            if(!col.includes(0))
                colToRemove.push(i);
        }

        rowsToRemove.forEach((rowIndex)=>{
            newShape[rowIndex].fill(0);
        });
        colToRemove.forEach((colIndex)=>{
            for( let j = 0; j < LENGTH; j++ ){
                newShape[j][colIndex] = 0;
            }
            //newShape[colIndex].fill(0);
        });

        // Update the score
        const scoreMultiplier = rowsToRemove.length+colToRemove.length/10 + .9
        setScore(score + (rowsToRemove.length+colToRemove.length)*1000*scoreMultiplier);

        return newShape;
    }

    return (
        <div id="gameboard-grid">
            <BlockUnitGrid params={params}></BlockUnitGrid>
        </div>
    );
}